import {AbstractControl, ValidatorFn} from "@angular/forms";

export function fileSizeValidator(maxSize: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value && control.value.size > maxSize * 1024 * 1024) {
      return { 'fileSizeExceeded': true };
    }
    return null;
  };
}
